import React from 'react';

import Typography from '../Typography';

export default () => (
  <div className={'logo'}>
    <svg
      width={'209'}
      height={'42'}
      viewBox={'0 0 209 42'}
      fill={'none'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={'M156.803 7.59961H146.81V41.1835H156.803V7.59961Z'}
        fill={'#D9D9D9'}
      />
      <path
        d={'M156.803 7.59961H146.81V41.1835H156.803V7.59961Z'}
        fill={'#4F77A0'}
      />
      <path
        d={'M169.313 15.2173H159.32V41.1835H169.313V15.2173Z'}
        fill={'#D9D9D9'}
      />
      <path
        d={'M169.313 15.2173H159.32V41.1835H169.313V15.2173Z'}
        fill={'#4F77A0'}
      />
      <path d={'M181.82 0H171.827V41.1866H181.82V0Z'} fill={'#D9D9D9'} />
      <path d={'M181.82 0H171.827V41.1866H181.82V0Z'} fill={'#4F77A0'} />
      <path
        d={
          'M208.5 15.2172V7.59961L186.605 7.60856V7.67125V41.1298V41.1835H208.5V33.5838H195.557V28.166H206.473V20.62H195.557V15.2172H208.5Z'
        }
        fill={'#D9D9D9'}
      />
      <path
        d={
          'M208.5 15.2172V7.59961L186.605 7.60856V7.67125V41.1298V41.1835H208.5V33.5838H195.557V28.166H206.473V20.62H195.557V15.2172H208.5Z'
        }
        fill={'#4F77A0'}
      />
      <path
        d={
          'M55.2458 7.12793C45.7118 7.12793 37.9808 14.859 37.9808 24.393C37.9808 33.927 45.7118 41.658 55.2458 41.658C64.7798 41.658 72.5109 33.927 72.5109 24.393C72.5109 14.856 64.7828 7.12793 55.2458 7.12793ZM55.2458 34.0882C49.9953 34.0882 45.7417 29.748 45.7417 24.39C45.7417 19.032 49.9983 14.6918 55.2458 14.6918C60.4964 14.6918 64.75 19.032 64.75 24.39C64.75 29.748 60.4964 34.0882 55.2458 34.0882Z'
        }
        fill={'#3DC2FF'}
      />
      <path
        d={
          'M33.7928 20.5185H17.265V28.0645H26.0588C24.6409 31.5987 21.238 34.0911 17.265 34.0911C14.6054 34.0911 12.2055 32.9748 10.4802 31.1808C8.79968 29.4316 7.76091 27.0377 7.76091 24.396C7.76091 19.0409 12.0175 14.6978 17.265 14.6978C19.9247 14.6978 22.3246 15.8142 24.0499 17.6111L29.4736 12.1845C26.3483 9.0592 22.032 7.12793 17.265 7.12793C7.73106 7.12793 0 14.859 0 24.393C0 29.16 1.93127 33.4762 5.05653 36.6015C8.18179 39.7268 12.4981 41.658 17.265 41.658C25.5394 41.658 32.0854 35.8344 33.7689 28.0645C34.0256 26.8795 34.5301 23.3363 33.7928 20.5185Z'
        }
        fill={'#3DC2FF'}
      />
      <path
        d={
          'M135.243 41.1835H143.568L131.461 7.59961H122.285L110.175 41.1835H118.5L120.509 35.6076H133.234L135.243 41.1835ZM123.228 28.0646L126.87 17.9604L130.515 28.0646H123.228Z'
        }
        fill={'#D9D9D9'}
      />
      <path
        d={
          'M135.243 41.1835H143.568L131.461 7.59961H122.285L110.175 41.1835H118.5L120.509 35.6076H133.234L135.243 41.1835ZM123.228 28.0646L126.87 17.9604L130.515 28.0646H123.228Z'
        }
        fill={'#4F77A0'}
      />
      <path
        d={
          'M110.089 20.5184H93.5608V28.0644H102.354C100.937 31.5986 97.5338 34.0911 93.5608 34.0911C90.9012 34.0911 88.5012 32.9747 86.7759 31.1807C85.0954 29.4315 84.0566 27.0376 84.0566 24.3959C84.0566 19.0409 88.3132 14.6978 93.5608 14.6978C96.2204 14.6978 98.6203 15.8141 100.346 17.6111L105.769 12.1874C102.644 9.06213 98.3278 7.13086 93.5608 7.13086C84.0268 7.13086 76.2957 14.8619 76.2957 24.3959C76.2957 29.1629 78.227 33.4792 81.3522 36.6044C84.4775 39.7297 88.7938 41.661 93.5608 41.661C101.835 41.661 108.381 35.8373 110.065 28.0674C110.321 26.8794 110.826 23.3362 110.089 20.5184Z'
        }
        fill={'#D9D9D9'}
      />
      <path
        d={
          'M110.089 20.5184H93.5608V28.0644H102.354C100.937 31.5986 97.5338 34.0911 93.5608 34.0911C90.9012 34.0911 88.5012 32.9747 86.7759 31.1807C85.0954 29.4315 84.0566 27.0376 84.0566 24.3959C84.0566 19.0409 88.3132 14.6978 93.5608 14.6978C96.2204 14.6978 98.6203 15.8141 100.346 17.6111L105.769 12.1874C102.644 9.06213 98.3278 7.13086 93.5608 7.13086C84.0268 7.13086 76.2957 14.8619 76.2957 24.3959C76.2957 29.1629 78.227 33.4792 81.3522 36.6044C84.4775 39.7297 88.7938 41.661 93.5608 41.661C101.835 41.661 108.381 35.8373 110.065 28.0674C110.321 26.8794 110.826 23.3362 110.089 20.5184Z'
        }
        fill={'#4F77A0'}
      />
    </svg>
    <Typography color={'medium-shade'}>
      Marketing platform by Plarium
    </Typography>
  </div>
);
